import React from 'react';
import { NewTabLink, Title } from 'shared/components/abstract/interactables';
import { TextSection } from 'shared/components/styled/layouts';

export default function DeviceHelp() {
  return (
    <>
      <Title title="Device Help" />
      <TextSection>
        <h5>Wired Devices</h5>
        <p>
          Tenants must register their device before plugging it into a Ethernet jack.
          This creates a number of radius records for our network&apos;s&nbsp;
          <NewTabLink link="https://en.wikipedia.org/wiki/IEEE_802.1X" text="802.1x" />
          &nbsp;authentication system.
        </p>
        <p>
          Wired device registration requires a&nbsp;
          <NewTabLink link="https://en.wikipedia.org/wiki/MAC_address" text="MAC Address" />
          &nbsp;in
          <strong>{' 1a:2b:3c:4d:5e:6f '}</strong>
          format.
        </p>
        <p>
          Tenants generally only do this once or twice to setup their own wireless router or
          PC.
        </p>
        <strong>Troubleshooting tips:</strong>
        <ul>
          <li>
            Check mac address is correct
          </li>
          <li>
            Check that the radius &apos;Auth-Type&apos; is set to &apos;Accept&apos;.
          </li>
          <li>
            Check that the radius &apos;Tunnel-Private-Group-Id&apos; matches the unit&apos;s VLAN.
          </li>
        </ul>

      </TextSection>
      <TextSection>
        <h5>Wireless Devices</h5>
        <p>
          In some buildings we install access points and provision wireless keys
          for tenant devices.
        </p>
        <p>
          In general these systems are more prone to failure,
          so it&apos;s important to know
          the different types of wireless setups that we have.
        </p>
        <p>
          Our wireless controllers use DPSKs - which is a Ruckus trademark that stands for&nbsp;
          <NewTabLink link="https://docs.ruckuswireless.com/unleashed/200.3/c-ZeroITandDPSK.html" text="Dynamic Pre-shared Key" />
          . On this site they are labeled simply as &apos;Key&apos; - its value being the
          password that can be used to log into the WLAN.
        </p>
        <h5>Virtual SmartZone (VSZ)</h5>
        <p>
          <NewTabLink link="https://support.ruckuswireless.com/product_families/18-virtual-smartzone-vsz" text="Ruckus Virtual SmartZone" />
          &nbsp;wireless is Ruckus&apos; newer solution for managed wireless.
          This offers some solutions to the above problems while also introducing new issues.
        </p>
        <p>
          A major difference to previous options is that it&apos;s
          <i>{' virtual '}</i>
          meaning that we don&apos;t have to install a physical controller
          on a rack in each complex.
        </p>
        <p>
          We utilize one version of the DPSK systems for getting tenants online
          within VSZ buildings:
          <strong>{' Group Keys '}</strong>
          These both aim to solve the problem of tenants
          having to find and manually enter macs. These also don&apos;t require an AP restart after
          being added.
        </p>

        <p>
          <strong>Group Keys</strong>
        </p>
        <p>
          A Group Key allows multiple devices to connect at the same time.
        </p>
        <p>
          We added this option when noticed that tenant devices
          were being disconnected every time a new key was created, deleted, or bound.
        </p>
        <p>
          In this setup we provision a Group Key for each unit in a building.
          When a tenant logs into
          Onboard they can see their key, and then connect all their devices to it.
        </p>
        <p>
          The main problem with this is that we don&apos;t get to collect mac addresses.
          This means we lose the ability to deauth or cleanup individual devices,
          which opens up avenues for abuse/password sharing within these complexes.
        </p>
        <p>
          Because of this, we will most likely recreate all group DPSKs every so often,
          which will cause significant friction for tenants.
        </p>
      </TextSection>
    </>
  );
}
